// extracted by mini-css-extract-plugin
module.exports = {"courseContainer":"DashboardPage_courseContainer__2b6oQ"};